/* tslint:disable */
import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import $ from 'jquery';
import AuthProvider from "../AuthProvider";
import { msalApp } from "../auth-utils";
import '../custom.css';
import 'react-toastify/dist/ReactToastify.css';
import Unauthorize from "./Unauthorize";
import Landing from './Landing_Page/Landing';
import { createRef } from 'react';


class Home extends Component {
    constructor(props) {
        super(props)
        this.state = {
            params: null,
            showUnauthorize: false,
            accessToken: '',
            vendorCustomer: null,
            prhCustomerColDef: null,
            customerClassList: null,
            customerList: null,
            customerClass: '',
            customer: '',
            prhpsClient: "",
            prhpsClientList: [],
            saveComponent: createRef(),
            searchAllFieldTextBox: React.createRef(),
            lnkPowerSearchList: React.createRef(),
            lnkSavedList: React.createRef(),
            lnkPowerSearch: React.createRef(),
            selectOption: 'addSelectedtoExising',
            selectSettingsOption: '',
            gridOptions: {
                defaultColDef: {
                    flex: 1,
                    minWidth: 100,
                    enableValue: true,
                    enableRowGroup: true,
                    enablePivot: true,
                    sortable: true,
                    filter: true,
                    resizable: true,
                },
                pagination: true,
                paginationPageSize: 10000,
                animateRows: true,
                accentedSort: true,
                enableRangeSelection: true,
                suppressRowClickSelection: true,
                autoGroupColumnDef: { minWidth: 200 },
                rowGroupPanelShow: 'always',
                rowSelection: 'multiple',
                sideBar: {
                    toolPanels: [
                        {
                            id: 'columns',
                            labelDefault: 'Columns',
                            labelKey: 'columns',
                            iconKey: 'columns',
                            toolPanel: 'agColumnsToolPanel',
                        },
                        {
                            id: 'filters',
                            labelDefault: 'Filters',
                            labelKey: 'filters',
                            iconKey: 'filter',
                            toolPanel: 'agFiltersToolPanel',
                        },
                    ],
                    defaultToolPanel: 'none',
                },
                overlayNoRowsTemplate: '<span></span>',
            },
            columnDefs: [],
            regionListtypes: [],
            scopeUserlists: [],
            selectedListtype: {},
            selectedListtypeFormat: [],
            selectedSearchRows: [],
            listtypeGridSettings: [],
            selectedListtypeGridSetting: {},
            pageInitComplete: false,
            totalCount: "0",
            tabValue: "1",
            location: "us",
            scope: "",
            searchText: "",
            advRows: [],
            isOptionsLoading: false,
            options: [],
            fetching: false,
            sourceFileTabVisible: true,
            destinationFileTabVisible: false,
            tempCreationTabVisible: false,
            jobCreationTabVisible: false,
            sourceFileTabClass: "tab-pane fade show",
            destinationFileTabClass: "tab-pane fade d-none",
            tempCreationTabClass: "tab-pane fade d-none",
            jobCreationTabClass: "tab-pane fade d-none",
            selectedSearchResults: '',
            upn: '',
            upnGroups: [],
            copied: false,
            retrievePersonalList: { listtypes: [], userlists: [], listdefaults: [], regions: [] },
            userlists: [],
            listtypes: [],
            listdefaults: [],
            regions: [],
            searchMode: 'and',
            loading: false,
            pageFirstLoad: true,
            showModal: false,
            settingName: '',
            settingOption: '',
            settingList: [],
            showNotification: false,
            showReplaceWarning: false,
            NotificationMessage: '',
            totalOrginalDocumentCount: "0",
            maxLimitExceed: false,
            DefaultTab: "",
            filterName: '',
            filterOption: '',
            listtypeGridFilters: [],
            showFilterModal: false,
            currentfilterrows: '',
            selectFilterOption: '',
            eReaderList: [],
            CharCountExceedMessage: '',
            showCharNotification: false,
            BiToken: props.BiToken,
            excelStyles: [
                {
                    id: 'textFormat',
                    dataType: 'string',
                },
                {
                    id: 'TextInNumberFormat',
                    numberFormat: {
                        format: "\@",
                    },
                },
                {
                    id: 'RightAlignNumber',
                    alignment: {
                        horizontal: 'Right', vertical: 'Bottom'
                    },
                }
            ]
        };

    };
    //let[searchParams, setSearchParams] = useSearchParams();
    authenticationVerification = () => {
        const requestOptions = {
            method: 'POST',
            headers: this.getHeaders()
        };
        this.setLoading(true);
        fetch(`/auth/verify`, requestOptions)
            .then(response => response.json())
            .then(response => {
                this.setLoading(false);
                if (response == undefined || response == null || response.userPrincipalName == undefined || response.userPrincipalName == null || response.userPrincipalName.trim().length == 0) {
                    msalApp.logout();
                }
            }).catch((reason) => {
                this.setLoading(false);
                this.addNotification('error', 'Session timedout or Unauthorized access!');
                //msalApp.logout();

            });
    }
    trace = (message, data) => {
        console.debug(message, data);
    }
    erroNotification = (message, err) => {
        this.authenticationVerification();
        if (err) {
            console.error('error', err);
            message = message + err;
        }
        this.addNotification('error', message);
    }
    successNotification = (message) => {
        this.addNotification('success', message);
    }
    infoNotification = (message) => {
        this.addNotification('info', message);
    }
    warningNotification = (message) => {
        this.addNotification('warning', message);
    }
    searchModeChanged = () => (e) => {
        const { name, value } = e.target;
        this.setState({ searchMode: value });
    };

    setLoading = (isLoading) => {
        this.setState({ loading: isLoading });
    }

    addNotification = (level, message) => {
        this.setLoading(false);
        if (level == null || level == undefined) { level = "info"; }
        let options= {
            position: 'top-right'
        };
        switch (level.trim().toLowerCase()) {
            case "error":
                this.trace("error:: " + message, null);
                toast.error(message, options);
                break;
            case "warning":
                this.trace("warn:: " + message, null);
                toast.warn(message, options);
                break;
            default:
                this.trace(level + ":: " + message, null);
                break;
        }

    };

    componentDidMount = () => {
        const qp = new URLSearchParams(window.location.search);
        this.setState({ params: qp.get('isbns') });
        /*  if (qp.get('isbns') && qp.get('isbns') != "") {
              window.history.replaceState({}, document.title, window.location.pathname);
          }*/
    }
    emptyUrlParams = () => {
        this.setState({ params: "" });
    }
    componentDidUpdate = () => {

        if (this.props.profile != null && this.props.profile != undefined
            && this.props.memberOf != null && this.props.memberOf != undefined
            && this.props.profile.userPrincipalName != null && this.props.profile.userPrincipalName != undefined && this.props.profile.userPrincipalName.trim().length > 0
            && this.props.memberOf.value != null && this.props.memberOf.value.length > 0
            && !this.state.pageInitComplete
        ) {
            this.setState({ pageInitComplete: true, upn: this.props.profile.userPrincipalName, upnGroups: this.props.memberOf.value, accessToken: this.props.tokenResponse.accessToken, BiToken: this.props.BiToken }
                , () => {
                 
                    if (this.state.accessToken != null && this.state.accessToken != undefined) {
                        $("#lnklogout").text("Logout");
                    }
                    else {
                        this.setState({ showUnauthorize: true });
                    }
                });
           
        }

    };

    getHeaders = () => {
        return { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.props.tokenResponse.accessToken };
    }


    retrieveVendorCustomer = (CustClass, ShipName, PRHPSClient) => {
        this.setState({ customerClass: CustClass, customer: ShipName });
        this.setState({ prhpsClient: PRHPSClient });
        //const payload = {
        //    CustClass: CustClass,
        //    ShipName: ShipName
        //};
        const payload = {
            PrhpsCustomer: PRHPSClient
        }
        const requestOptions = {
            method: 'POST',
            headers: this.getHeaders(),
            body: JSON.stringify(payload)
        };

        let url = '/user/retrievevendorcustomerlists';
        this.state.saveComponent.current.setVendorLoading(true);
        fetch(url, requestOptions)
            .then(response => response.json())
            .then(response => {
                this.setState({ vendorCustomer: response.vendorCustomers }
                    , () => {
                        this.state.saveComponent.current.setVendorLoading(false);
                        this.state.saveComponent.current.setLoading(false);
                    });
            })
            .catch(reason => {
                console.log('retrive failed');
            });
    }

    retrievePRHCustomer = (input) => {
        const payload=
        {
            vendorcustomer: input.vendorCustomer,
            noofsearchresult: input.noOfSearchResult,
            prhfilter: input.prhFilter

        };
        const requestOptions = {
            method: 'POST',
            headers: this.getHeaders(),
            body: JSON.stringify(payload)
        };

        let url= '/user/retrieveprhcustomerdet';
        this.state.saveComponent.current.setLoading(true);
        fetch(url, requestOptions)
            .then(response => response.json())
            .then(response => {
                this.state.saveComponent.current.setLoading(false);
                this.state.saveComponent.current.updateRowDataToPRHGrid(response.data);
            })
            .catch(reason => {
                this.erroNotification('retrive failed ', reason);
                console.log('retrive failed');
            });
    }

    getCustomerClass = async () => {
        const requestOptions = {
            method: 'POST',
            headers: this.getHeaders(),
        };
        let url = '/user/RetrieveCustomerClass';
        const response = await fetch(url, requestOptions);
        const result = await response.json();
        if (result) {
            this.setState({ customerClassList: result }, () => {
                var custClass= result;
                if (custClass.length > 0)
                    this.setState({ customerClass: custClass[0]["custClass"] }, () => { this.retrieveVendorCustomer(this.state.customerClass, this.state.customer, this.state.prhpsClient); });

            });

        }
    }

    getCustomerNames = async () => {
        const requestOptions = {
            method: 'POST',
            headers: this.getHeaders(),
        };
        let url = '/user/RetrieveShipToNames';
        const response = await fetch(url, requestOptions);
        const result = await response.json();
        if (result) {
            this.setState({ customerList: result });
        }
    }

    getPRHPSClient = async () => {
        const requestOptions = {
            method: 'POST',
            headers: this.getHeaders(),
        };
        let url= '/user/RetrievePrhpsCust';
        try {
            const response = await fetch(url, requestOptions);
            const result = await response.json();
            if (result) {
                this.setState({ prhpsClientList: result }, () => {
                    var prhpsClient= result;
                    if (prhpsClient.length > 0)
                        this.setState({ prhpsClient: prhpsClient[0]["prhpsCustomer"] }, () => { this.retrieveVendorCustomer(this.state.customerClass, this.state.customer, this.state.prhpsClient); });

                });

            }
        }
        catch (err) {
            this.erroNotification('RetrievePrhpsCust failed!', err);
        }

    }

    matchCustomer = async (data) => {
        data.UpdateUser = this.state.upn;
        const requestOptions = {
            method: 'POST',
            headers: this.getHeaders(),
            body: JSON.stringify(data)
        };

        let url= '/user/updatecustomer';
        var response = await fetch(url, requestOptions);
        if (response.ok) {
            this.retrieveVendorCustomer(this.state.customerClass, this.state.customer, this.state.prhpsClient);
        }
    }


    //getDefaultColumnDefs = async () => {
    //    const requestOptions = {
    //        method: 'GET',
    //        headers: this.getHeaders(),
    //    };
    //    let url: string = '/search/getcolumndefs?catalog=prhcatalogsearch&indexName=prhpsnewclient';
    //    try {
    //        const response = await fetch(url, requestOptions);
    //        const result = await response.json();
    //        if (result) {
    //            this.setState({ prhCustomerColDef: result });
    //            this.state.saveComponent.current.gridOptionInit(result);

    //        };
    //    }
    //    catch (error) {
    //        this.erroNotification('getDefaultColumnDefs failed!', error);
    //    }
    //}

    findcolformat = (colFieldName, columnName) => {
        let rtnVal= {};
        try {
            rtnVal = this.state.selectedListtypeFormat.find((item) => { return item.indexColumn.toLowerCase() == colFieldName.toString().toLowerCase(); });
            if (rtnVal != null && rtnVal != undefined) {
                return rtnVal;
            }
            rtnVal = this.state.selectedListtypeFormat.find((item) => { return item.indexColumn.toLowerCase() == columnName.toString().toLowerCase(); })
        }
        catch {

        }
        return rtnVal;
    }

    gridExportToExcel = (exportGridOptions) => {
        var columnsForExport = [];
       // var allColumns = exportGridOptions.columnApi.getAllDisplayedColumns();

        //allColumns.forEach((element: any) => {
        //    if (element.colDef.headerName != null && element.colDef.headerName != undefined && element.colDef.headerName.trim().length > 0) {
        //        columnsForExport.push(element);
        //    }
        //});


        let params= {
            allColumns: false,
            columnGroups: true,
            columnKeys: columnsForExport,
            processCellCallback: (params) => {
                try {
                    let exportPadValue = "";
                    try {
                        let colFormat= this.findcolformat(params.column.colDef.field, params.column.colDef.headerName);
                        if (colFormat != null && colFormat != undefined && colFormat.exportPadValue != null && colFormat.exportPadValue != undefined) {
                            exportPadValue = colFormat.exportPadValue
                        }
                    }
                    catch { }
                    if (params.column.colDef.valueFormatter) {
                        return exportPadValue + params.column.colDef.valueFormatter(params);
                    } else {
                        /*return exportPadValue + params.value;*/
                        return params.value;
                    }

                }
                catch {
                    return params.value;
                }
            },
        };

        exportGridOptions.api.exportDataAsExcel(params);
    }

    exportGridToExcel = (e) => {
        e.preventDefault();
        this.gridExportToExcel(this.state.gridOptions);
    }


    agFormatDate = () => {

    }

    tabChange = (value) => {
        switch (value) {
            case "2":
                setTimeout(() => {
                    this.setState({
                        sourceFileTabVisible: false,
                        destinationFileTabVisible: true,
                        tempCreationTabVisible: false,
                        jobCreationTabVisible: false,
                        //powerSearchTabClass: "tab-pane fade d-none",
                        //powerSearchListTabClass: "tab-pane fade show tab-content-position",
                        //saveListTabClass: "tab-pane fade d-none",
                        //selectOption: "0"
                    });
                }, 500);
                return;
            case "3":
                setTimeout(() => {
                    this.setState({
                        sourceFileTabVisible: false,
                        destinationFileTabVisible: false,
                        tempCreationTabVisible: true,
                        jobCreationTabVisible: false,
                        //powerSearchTabClass: "tab-pane fade d-none",
                        //powerSearchListTabClass: "tab-pane fade d-none",
                        //saveListTabClass: "tab-pane fade show tab-content-position",
                        //selectOption: "0"
                    });
                }, 500);
                return;
            case "4":
                setTimeout(() => {
                    this.setState({
                        sourceFileTabVisible: false,
                        destinationFileTabVisible: false,
                        tempCreationTabVisible: false,
                        jobCreationTabVisible: true,
                        //powerSearchTabClass: "tab-pane fade d-none",
                        //powerSearchListTabClass: "tab-pane fade d-none",
                        //saveListTabClass: "tab-pane fade show tab-content-position",
                        //selectOption: "0"
                    });
                }, 500);

                return;
            default:
                setTimeout(() => {
                    this.setState({
                        sourceFileTabVisible: true,
                        destinationFileTabVisible: false,
                        tempCreationTabVisible: false,
                        jobCreationTabVisible: false,
                        //powerSearchTabClass: "tab-pane fade d-none",
                        //powerSearchListTabClass: "tab-pane fade d-none",
                        //saveListTabClass: "tab-pane fade show tab-content-position",
                        //selectOption: "0"
                    });
                }, 500);
                return;
        }
    }


    render() {
        return (
            <React.Fragment>
                <div className="dashboard app-font">
                    <ToastContainer autoClose={3000} />
                    <div id="tabSaveList" role="tabpanel">
                        {(this.state.showUnauthorize) ?
                            (<Unauthorize />)
                            :
                            <>
                                <Landing audience={this.props.audience} accessTokens={this.state.accessToken} BiTokens={this.props.BiToken} upn={this.state.upn} params={this.state.params} isbnData={this.props.isbnData} setIsbnData={this.props.setIsbnData}
                                    upnGroups={this.state.upnGroups} emptyUrlParams={this.emptyUrlParams}
                                    userInitials={this.props.userInitials} DKAccordSetting={this.props.DKAccordSetting} USAccordSetting={this.props.USAccordSetting}
                                    setUSAccordSetting={this.props.setUSAccordSetting} setDKAccordSetting={this.props.setDKAccordSetting}
                                ></Landing>
                            </>
                        }
                    </div>
                </div>
            </React.Fragment>
        );
    }
};

export default AuthProvider(Home);